
import Vue from "vue";
import { ProductCSVImportExistingBarCodeHandling, ProductCSVImportExistingProductHandling, ProductCSVImportNewProductsHandling, ProductCSVImportProductMatchingMethod, ProductService } from "../../services/product-service";
import AppFileUpload from "../FileUploadDropAndProgress.vue";
import { AuthService } from "../../services/auth-service";
import AppMissingModule from "@/components/common/MissingModule.vue";
import { ISelectItem } from "winfakt-vue-components";
import { getEnumKeys, getEnumValueFromKey } from "@/utils/enum";
import { HttpError } from "@/utils/services/http-error";

export default Vue.extend({
	data() {
		return {
			file: null as null | File,
			uploading: false,
			existingProductHandling: ProductCSVImportExistingProductHandling.UPDATE,
			useCommaSeperator: false,
			createNewProducts: true,
			productMatchingMethod: ProductCSVImportProductMatchingMethod.SKU,
			existingBarcodeHandling: ProductCSVImportExistingBarCodeHandling.IGNORE
		};
	},
	computed: {
		isAllowed() {
			return AuthService.hasModule(12);
		},
		allowedExtensions():string[] {
			return ["csv", "txt", "xlsx", "xls", "ods"];
		},
		existingProductHandlingItems():ISelectItem<ProductCSVImportExistingProductHandling>[]{
			return getEnumKeys(ProductCSVImportExistingProductHandling).map(k=>{
				let value =getEnumValueFromKey(ProductCSVImportExistingProductHandling, k);
				return {
					text: this.$ct(`csv-import-existing-product-handling.${k}`),
					value,
				} as ISelectItem<ProductCSVImportExistingProductHandling>;
			});
		},
		productMatchingMethods():ISelectItem<ProductCSVImportProductMatchingMethod>[] {
			return getEnumKeys(ProductCSVImportProductMatchingMethod).map(k=>{
				return {
					text: this.$ct(`csv-import-product-matching-method.${k}`),
					value: getEnumValueFromKey(ProductCSVImportProductMatchingMethod, k)
				}as ISelectItem<ProductCSVImportProductMatchingMethod>;
			});
		},
		existingBarcodeHandlingItems():ISelectItem<ProductCSVImportExistingBarCodeHandling>[]{
			return getEnumKeys(ProductCSVImportExistingBarCodeHandling).map(k=>{
				let value =getEnumValueFromKey(ProductCSVImportExistingBarCodeHandling, k);
				return {
					text: this.$ct(`csv-import-existing-barcode-handling.${k}`),
					value,
				} as ISelectItem<ProductCSVImportExistingBarCodeHandling>;
			});
		},
		isExcel():boolean {
			if (!this.file) return false;
			return this.file.type.toLowerCase().startsWith("application/");
		}
	},
	methods: {
		cancel() {
			this.$emit("close");
		},
		async upload() {
			if (!this.file) {
				return;
			}
			this.uploading = true;
			let newProdHandling = ProductCSVImportNewProductsHandling.CREATE;
			if (!this.createNewProducts) {
				newProdHandling = ProductCSVImportNewProductsHandling.IGNORE;
			}
			try {
				if (this.isExcel){
					var job = await ProductService.importProductsExcel(this.file, this.existingProductHandling, newProdHandling, this.productMatchingMethod,
						this.existingBarcodeHandling);
				}else{
					var job = await ProductService.importProductsCSV(this.file,
						this.existingProductHandling, newProdHandling, this.productMatchingMethod, this.existingBarcodeHandling, this.useCommaSeperator);
				}
				this.$emit("job", job);
				this.$emit("close");
			} catch (hErr) {
				let err = hErr as HttpError;
				if (err.message.startsWith("Unkown error: Invalid col")) {
					this.$wf.notify(this.$ct("csv-import-invalid-cols"), "danger", 3000, "exclamation-triangle");
				}
			}
			this.uploading = false;
		},
	},
	components: {
		AppFileUpload,
		AppMissingModule
	},
	i18nEx: {
		componentPrefix: "components.products"
	}
});
